<template>
  <div>
    <b-card header-tag="header" no-body>
      <template #header>
        <header-sagres titulo="Homologar edital" breakpoint="xl" />
      </template>

      <b-card>
        <b-table
          :fields="fields"
          :items="itemsComputed"
          :busy="tableBusy"
          responsive="sm"
          hover
          no-border-collapse
          striped
          stacked="xl"
        >
          <template #cell(arquivo)="data">
            <div v-if="data.item.id !== -1">
              <default-form-validation-provider
                label=""
                rules=""
                v-slot="defaultState"
              >
                <div
                  v-if="data.item.anexosEnviados !== null"
                  class="d-flex justify-content-center align-items-center flex-wrap"
                >
                  <span>{{ data.item.anexosEnviados.NomeAnexo || " " }}</span>
                </div>
                <b-form-file
                  v-else
                  placeholder="Nenhum arquivo selecionado"
                  accept=".pdf"
                  v-model="file"
                  :state="defaultState.state"
                  drop-label="Arraste o arquivo"
                  @input="adicionarAnexo(idEdital, data.item.id, file)"
                  :disabled="detalhes"
                />
              </default-form-validation-provider>
            </div>

            <div v-else>
              <default-form-validation-provider
                noLabel
                v-slot="defaultState"
                v-if="data.item.descricao === 'Data de Homologação'"
              >
                <div class="d-flex justify-content-center">
                  <b-form-datepicker
                    locale="pt-BR"
                    placeholder="Escolha uma data"
                    class="mb-2"
                    :max="hoje"
                    :state="defaultState.state"
                    v-model="DtHomologacao"
                    size="sm"
                    :disabled="detalhes"
                  />
                </div>
              </default-form-validation-provider>
            </div>
          </template>
          <template #cell(actions)="data">
            <div
              v-if="data.item.descricao === 'Data de Homologação'"
              class="d-flex justify-content-center"
            >
              <b-button
                variant="secondary"
                type="submit"
                size="sm"
                @click="addDataHomologacao"
                class="mr-3"
                :disabled="DtHomologacao === null"
                v-if="!detalhes"
                >Salvar</b-button
              >
              <b-button
                variant="secondary"
                type="submit"
                size="sm"
                @click="alertaRemoverData"
                :disabled="DtHomologacao === null"
                v-if="!detalhes"
                ><font-awesome-icon icon="rotate-left"
              /></b-button>
            </div>

            <div v-else>
              <b-button
                size="sm"
                @click="converterIDsDownload(data.item.id, data.item.descricao)"
                class="mr-3"
                :disabled="
                  !listaAnexos.some(
                    (anexo) => anexo.IdTipoAnexo === data.item.id
                  )
                "
                ><font-awesome-icon icon="download" />
              </b-button>
              <b-button
                size="sm"
                @click="converterIDs(data.item.id, data.item.descricao)"
                :disabled="
                  !listaAnexos.some(
                    (anexo) => anexo.IdTipoAnexo === data.item.id
                  )
                "
                v-if="!detalhes"
                ><font-awesome-icon icon="trash"
              /></b-button>
            </div>
          </template>
          <template #cell(status)="data">
            {{
              data.item.id === undefined
                ? "-"
                : data.item.id === -1
                ? temDataHomologacao
                  ? "Cadastrada"
                  : "Pendente"
                : listaAnexos.some(
                    (anexo) =>
                      anexo.IdTipoAnexoNavigation?.IdTipoAnexo === data.item.id
                  )
                ? "Enviado"
                : "Pendente"
            }}
          </template>
        </b-table>
      </b-card>
    </b-card>
  </div>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Ref, Vue, Watch } from "vue-property-decorator";
import HeaderSagres from "@/components/shared/HeaderSagres.vue";
import { fieldsHomologacao } from "@/types/atos-pessoal/concursos/fields-homologacao";
import { TableField } from "@/types/table-field";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import concursoService from "@/services/atos-pessoal/concursoService";
import { AnexoEdital } from "@/types/atos-pessoal/concursos/anexo";
import { TIPO_EDITAL_CODIGO } from "@/types/atos-pessoal/concursos/tipo-edital";
const CompProps = Vue.extend({
  name: "AbaHomologarEdital",
  props: {
    idEdital: {
      type: Number,
      required: true,
    },
    idTipoEdital: {
      type: Number,
      default: 0,
    },
    dataHomologacao: {
      type: String,
      required: false,
    },
    contador: {
      type: Number,
      required: true,
    },
    detalhes: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    HeaderSagres,
    DefaultFormValidationProvider,
  },
});

@Component
export default class AbaHomologarEdital extends mixins(UtilsTS, CompProps) {
  items: Array<{
    descricao: string;
  }>;

  listaTipos: Array<{
    IdTipoAnexo?: number;
    DsTipoAnexo: string;
    anexosEnviados?: AnexoEdital;
  }> = [];

  listaAnexos: AnexoEdital[] = [];

  fields: TableField[] = fieldsHomologacao;

  hoje = new Date().toISOString().split("T")[0];

  tableBusy = false;

  file: AnexoEdital | null = null;

  DtHomologacao: string | null = null;

  get temDataHomologacao() {
    return Boolean(this.DtHomologacao);
  }

  get itemsComputed() {
    return this.listaTipos
      .map((item) => ({
        id: item.IdTipoAnexo,
        descricao: item.DsTipoAnexo,
        anexosEnviados:
          this.listaAnexos.find(
            (anexo) => anexo.IdTipoAnexo === item.IdTipoAnexo
          ) || null,
      }))
      .concat({
        id: -1,
        descricao: "Data de Homologação",
        anexosEnviados: null,
      });
  }

  async mounted() {
    await this.listarTiposAnexo();
    await this.listarAnexos();
  }

  @Watch("dataHomologacao", { immediate: true })
  onDataHomologacaoChange(novaData?: string) {
    this.DtHomologacao = this.normalizarDataParaInput(novaData);
  }

  normalizarDataParaInput(data?: string) {
    if (!data) return null;
    return data.split("T")[0];
  }

  @Watch("contador")
  atualizar(newV) {
    if (newV) {
      this.listarAnexos();
    }
  }

  @Watch("idTipoEdital")
  onTipoEditalChange() {
    this.listarTiposAnexo();
  }

  async adicionarAnexo(idedital, idtipoarquivo, anexo) {
    if (this.file === null) return;
    const data = {
      idEdital: idedital,
      tipoAnexo: idtipoarquivo,
      Anexo: anexo,
    };
    try {
      this.tableBusy = true;
      await concursoService.adicionarAnexo(data);
      this.$toast.success("Anexo adicionado com sucesso!");
      this.listarAnexos();
      this.$emit("atualizarEdital");
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.file = null;
      this.tableBusy = false;
    }
  }

  async listarTiposAnexo() {
    if (!this.idTipoEdital) return;
    try {
      this.tableBusy = true;
      const response = await concursoService.listarTiposArquivo(
        TIPO_EDITAL_CODIGO[this.idTipoEdital],
        "HML"
      );
      this.listaTipos = response;
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.tableBusy = false;
    }
  }

  async listarAnexos() {
    try {
      this.tableBusy = true;
      const response = await concursoService.listarAnexos(
        Number(this.idEdital)
      );
      this.listaAnexos = response;
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.tableBusy = false;
    }
  }

  async addDataHomologacao() {
    try {
      this.tableBusy = true;
      const response = await concursoService.homologarData(
        this.idEdital,
        this.DtHomologacao
      );
      if (response) this.$toast.success("Data cadastrada com sucesso!");
      this.$emit("atualizarEdital");
    } catch (error: any) {
      this.tratarError(error);
      console.error("Erro ao cadastrar data", error);
    } finally {
      this.tableBusy = false;
    }
  }

  async limparDataHomologacao() {
    try {
      this.DtHomologacao = null;
      this.tableBusy = true;
      const response = await concursoService.homologarData(
        this.idEdital,
        this.DtHomologacao
      );
      if (response) this.$toast.success("Data removida com sucesso!");
      this.$emit("atualizarEdital");
    } catch (error: any) {
      this.tratarError(error);
      console.error("Erro ao remover data data", error);
    } finally {
      this.tableBusy = false;
    }
  }

  async excluirAnexo(id: number) {
    try {
      this.tableBusy = true;
      const response = await concursoService.excluirAnexo(id);
      this.$toast.success("Anexo excluído com sucesso");
      this.listaAnexos = this.listaAnexos.filter(
        (a: AnexoEdital) => a.IdAnexo !== id
      );
      this.listarAnexos();
      this.$emit("atualizarEdital");
      return response;
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.tableBusy = false;
    }
  }

  async baixarAnexo(nomeArquivo: string, idArquivo: number) {
    try {
      this.tableBusy = true;
      const response = await concursoService.baixarAnexo(idArquivo);
      this.download(nomeArquivo, response.data);
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.tableBusy = false;
    }
  }

  converterIDs(id: number, descricao: string) {
    const idAnexoEdital = Number(
      this.listaAnexos.find((anexo) => anexo.IdTipoAnexo === id)!.IdAnexo
    );
    this.alertaAnexoRemove(idAnexoEdital, descricao);
  }
  converterIDsDownload(id: number, descricao: string) {
    const idAnexoEdital = Number(
      this.listaAnexos.find((anexo) => anexo.IdTipoAnexo === id)!.IdAnexo
    );
    this.baixarAnexo(descricao, idAnexoEdital);
  }
  alertaAnexoRemove(IdAnexo: number, nome: string) {
    this.$bvModal
      .msgBoxConfirm(`Deseja remover o anexo ${nome}?`, {
        buttonSize: "sm",
        cancelTitle: "Cancelar",
        cancelVariant: "outline-secondary",
        centered: true,
        headerBgVariant: "secondary",
        headerTextVariant: "light",
        okTitle: "Confirmar",
        okVariant: "secondary",
        title: "Remover anexo",
      })
      .then((value) => {
        if (value) this.excluirAnexo(IdAnexo);
      })
      .catch((error) => {
        console.error(
          `Erro ao operar o dialogo de alerta de remoção de anexo`,
          error
        );
      });
  }

  alertaRemoverData() {
    this.$bvModal
      .msgBoxConfirm(`Deseja remover a data de homologação?`, {
        buttonSize: "sm",
        cancelTitle: "Cancelar",
        cancelVariant: "outline-secondary",
        centered: true,
        headerBgVariant: "secondary",
        headerTextVariant: "light",
        okTitle: "Confirmar",
        okVariant: "secondary",
        title: "Remover anexo",
      })
      .then((value) => {
        if (value) this.limparDataHomologacao();
      })
      .catch((error) => {
        console.error(
          `Erro ao operar o dialogo de alerta de remoção de data`,
          error
        );
      });
  }
}
</script>

<style scoped>
@media screen and (max-width: 618px) {
  div.botoes-acoes-wrapper {
    width: 100%;
    padding-top: 0.5rem;
  }
}
</style>
